import { MatPaginatorIntl } from '@angular/material/paginator';

export function getPersianPaginatorIntl(): MatPaginatorIntl {
  const paginatorIntl = new MatPaginatorIntl();

  paginatorIntl.itemsPerPageLabel = 'تعداد در هر صفحه:';
  paginatorIntl.nextPageLabel = 'صفحه بعد';
  paginatorIntl.previousPageLabel = 'صفحه قبل';
  paginatorIntl.firstPageLabel = 'صفحه اول';
  paginatorIntl.lastPageLabel = 'صفحه آخر';

  paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `۰ از ${length}`;
    }

    const startIndex = page * pageSize;
    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;

    return `${startIndex + 1} – ${endIndex} از ${length}`;
  };

  return paginatorIntl;
}
